import { render, staticRenderFns } from "./baseSelectTable.vue?vue&type=template&id=707b1c90&scoped=true"
import script from "./baseSelectTable.vue?vue&type=script&lang=js"
export * from "./baseSelectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b1c90",
  null
  
)

export default component.exports